import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useShortcut } from 'utils/hooks/keyboard/useShortcut';
import ListItem from 'components/ListItem';
import {
  setPaymentSelected,
  deletePayment,
  setPaymentDecimalEdit,
  setPaymentEditIndex,
} from 'actions/Payments';
import { getPaymentSelected } from 'reducers/Payments';

const ClosePayment = ({ voidHandler }) => {
  const dispatch = useDispatch();

  const paymentSelected = useSelector(getPaymentSelected);

  const escapeHandler = async () => {
    if (paymentSelected !== '') {
      dispatch(setPaymentSelected(''));
      dispatch(deletePayment({ key: paymentSelected }));
      dispatch(setPaymentDecimalEdit(false));
      dispatch(setPaymentEditIndex(0));
    } else {
      return voidHandler();
    }
  };

  useShortcut('cancel', escapeHandler, 20);

  const cancelPayment = () => voidHandler();

  return (
    <ListItem
      data-testid="cancel-payment-button"
      variant="grid_red"
      action={cancelPayment}
    >
      <span className="icon_close" />
    </ListItem>
  );
};

export default ClosePayment;
